
import { useTranslation, Trans } from "react-i18next";
import { ArrowRight } from "lucide-react";




const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="pt-24 md:pt-32 lg:pt-40 pb-16 md:pb-24 lg:pb-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto">
          {/* Main Heading */}
          <h1 className="heading-hero mb-8">
            <Trans
              i18nKey="hero.title"
              components={[
                <span className="font-serif italic" key="0" />,
                <span className="text-[#3ECFC3]" key="1" />
              ]}
            />
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl font-semibold text-foreground/90 mb-6">
            {t("hero.subtitle")}
          </p>

          {/* Description */}
          <p className="body-large text-muted-foreground max-w-2xl mx-auto mb-20">
            {t("hero.description")}
          </p>

          {/* CTA Button */}
          <a href="#pricing" className="btn-primary text-base md:text-lg py-4 px-8">
            {t("hero.cta")}
            <ArrowRight className="w-5 h-5 ml-2" />
          </a>
        </div>
      </div>
    </section>
  );
};


export default HeroSection;
